import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { completenessLevelForScore, COMPLETENESS_LEVEL_TRANSLATION_KEY } from '@constants/companies';
import ProfileProgress from '@components/ProfileProgress';

const Wrapper = styled('div')({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
});

const LevelLabel = styled(Typography)({
    color: 'var(--text-primary)',
    fontWeight: 500,
});

const ScoreReadout = ({ percent }) => {
    const { t } = useTranslation();
    const level = completenessLevelForScore(percent);
    const levelLabel = t(COMPLETENESS_LEVEL_TRANSLATION_KEY[level]);

    return (
        <Wrapper aria-label={`${percent}% ${levelLabel}`}>
            <ProfileProgress value={percent} level={level} />
            <LevelLabel variant="body2" component="span">
                {levelLabel}
            </LevelLabel>
        </Wrapper>
    );
};

export default ScoreReadout;
